/**
 * CurrencySelector Component
 * Toggles between MAD, EUR, and USD with a styled pill button group.
 * Matches LanguageSwitcher styling (same height, fonts, CSS variables, active state).
 */
import React from 'react';
import {
  Button,
  ButtonGroup,
  Tooltip,
} from '@mui/material';
import { useCurrency, CurrencyCode } from '../../context/CurrencyContext';

const currencies: { code: CurrencyCode; label: string }[] = [
  { code: 'MAD', label: 'MAD' },
  { code: 'EUR', label: 'EUR' },
  { code: 'USD', label: 'USD' },
];

const CurrencySelector: React.FC = () => {
  const { currency, setCurrency } = useCurrency();

  return (
    <Tooltip title="Currency / Devise / العملة">
      <ButtonGroup
        size="small"
        variant="outlined"
        aria-label="Currency selector"
        sx={{
          '& .MuiButton-root': {
            minWidth: 32,
            px: 0.75,
            py: 0.25,
            fontSize: '11px',
            fontWeight: 600,
            fontFamily: 'var(--font-body)',
            letterSpacing: '0.02em',
            borderColor: 'var(--color-border)',
            color: 'var(--color-text-muted)',
            height: 28,
            '&:hover': {
              borderColor: 'var(--color-accent)',
              bgcolor: 'var(--color-accent-bg)',
              color: 'var(--color-text-primary)',
            },
            transition: 'all var(--transition-fast)',
          },
        }}
      >
        {currencies.map((c) => (
          <Button
            key={c.code}
            onClick={() => setCurrency(c.code)}
            aria-label={c.label}
            aria-pressed={currency === c.code}
            sx={{
              bgcolor: currency === c.code
                ? 'var(--color-accent-bg)'
                : 'transparent',
              borderColor: currency === c.code
                ? 'var(--color-accent) !important'
                : 'var(--color-border)',
              color: currency === c.code
                ? 'var(--color-accent-hover)'
                : 'var(--color-text-muted)',
              fontWeight: currency === c.code ? 700 : 600,
              '&:hover': {
                bgcolor: currency === c.code
                  ? 'var(--color-accent-bg)'
                  : 'var(--color-bg-secondary)',
              },
            }}
          >
            {c.label}
          </Button>
        ))}
      </ButtonGroup>
    </Tooltip>
  );
};

export default CurrencySelector;
